<template>
  <UppyXHRFileUploader
    title="Choose Sample File (Optional)"
    :url="url"
    :max-files="5"
    :file-types="['.png', '.jpg', '.jpeg', '.psd', '.tif']"
    :meta="meta"
    :headers="headers"
    @uploaded="setOrderSampleImage"
    @removed="removeFile"
    @upload="$emit('processing', true)"
    @complete="$emit('complete', true)"
    dashboard-height="80%"
    class="sample-image"
  >
    <template #label>
      <div class="d-flex align-items-center justify-content-center h-100">
        <div class="pr-3" style="font-size:3.5rem">
          <i class="text-dark-50 flaticon-upload-1"></i>
        </div>
        <div>
          <p class="h5">Upload <strong>Sample files</strong> (Optional)</p>
          <p>PNG, JPG, PSD, or TIF (max 5 images)</p>
        </div>
      </div>
    </template>
  </UppyXHRFileUploader>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UppyXHRFileUploader from "./UppyXHRFileUploader.vue";

export default {
  components: {
    UppyXHRFileUploader,
  },
  computed: {
    ...mapGetters({
      options: "upload/options",
      images: "order/sampleImages",
      orderUuid: "order/uuid",
    }),
    url() {
      return process.env.VUE_APP_API_URL + "/sample/images";
    },
    meta() {
      return {
        token: this.orderUuid,
      };
    },
    headers() {
      return {
        Authorization: this.options.headers.Authorization,
      };
    },
  },

  methods: {
    ...mapActions({
      setSampleImage: "order/setSampleImage",
      deleteSampleImage: "order/deleteSampleImage",
    }),

    setOrderSampleImage(data, response) {
      this.setSampleImage({
        image: { uppy_id: data.id, ...response.body },
      });
    },

    removeFile(file) {
      let image = this.images.find((img) => {
        return img.uppy_id === file.id;
      });

      if (image) {
        this.deleteSampleImage(image);
      }
    },
  },
};
</script>

<style lang="css">
.sample-image .uppy-Dashboard-inner {
  height: 100% !important;
}
</style>
